package anjuros.development.modules

import anjuros.development.components.language.ResKey

enum class Review(
    val author: String,
    val source: ResKey,
    val review: ResKey

) {
    Review1(
        author = "Ewelina",
        source = ResKey.REVIEW_BOOKING,
        review = ResKey.REVIEW1_DESC
    ),
    Review2(
        author = "Daniel",
        source = ResKey.REVIEW_BOOKING,
        review = ResKey.REVIEW2_DESC
    ),
    Review3(
        author = "Jacek",
        source = ResKey.REVIEW_GOOGLE,
        review = ResKey.REVIEW3_DESC
    ),
    Review4(
        author = "Michał",
        source = ResKey.REVIEW_GOOGLE,
        review = ResKey.REVIEW4_DESC
    ),
    Review5(
        author = "paweleksw",
        source = ResKey.REVIEW_GOOGLE,
        review = ResKey.REVIEW5_DESC
    ),
    Review6(
        author = "Justyna",
        source = ResKey.REVIEW_GOOGLE,
        review = ResKey.REVIEW6_DESC
    ),
    Review7(
        author = "Asia",
        source = ResKey.REVIEW_GOOGLE,
        review = ResKey.REVIEW7_DESC
    ),
    Review8(
        author = "Karol",
        source = ResKey.REVIEW_GOOGLE,
        review = ResKey.REVIEW8_DESC
    ),
    Review9(
        author = "Dominik",
        source = ResKey.REVIEW_GOOGLE,
        review = ResKey.REVIEW9_DESC
    ),
    Review10(
        author = "dnamica",
        source = ResKey.REVIEW_GOOGLE,
        review = ResKey.REVIEW10_DESC
    )
}